import { useState } from 'react'
import { CheckCircle2, Circle, Shield } from 'lucide-react'

interface AndroidVpnConfirmProps {
  onConfirm: () => void
}

export default function AndroidVpnConfirm({ onConfirm }: AndroidVpnConfirmProps) {
  const [confirmed, setConfirmed] = useState(false)

  return (
    <div className="space-y-5">
      <div className="flex flex-col items-center gap-3">
        <div className="w-14 h-14 rounded-full bg-brand-light flex items-center justify-center">
          <Shield size={28} className="text-brand" />
        </div>
        <div className="text-center">
          <p className="text-base font-semibold text-gray-900">Allow VPN on the device</p>
          <p className="text-sm text-gray-500 mt-1">
            A VPN prompt will appear on the child's phone. This is required for web content filtering to work.
          </p>
        </div>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
        <p className="text-sm text-amber-800">
          On the child's Android phone, tap <strong>"OK"</strong> when prompted to allow Unbreakable to set up a VPN connection. If no prompt has appeared yet, open the Unbreakable app on the device.
        </p>
      </div>

      <button
        onClick={() => setConfirmed(prev => !prev)}
        className="w-full text-left flex items-start gap-3 p-3 rounded-xl border border-gray-200 hover:border-brand transition-colors"
      >
        {confirmed ? (
          <CheckCircle2 size={20} className="text-green-500 mt-0.5 shrink-0" />
        ) : (
          <Circle size={20} className="text-gray-300 mt-0.5 shrink-0" />
        )}
        <div>
          <p className="font-medium text-gray-900 text-sm">I've allowed the VPN on the device</p>
          <p className="text-xs text-gray-500 mt-1">
            The VPN connection request has been accepted on the child's phone
          </p>
        </div>
      </button>

      <button
        onClick={onConfirm}
        disabled={!confirmed}
        className="w-full py-3 bg-brand text-white rounded-xl hover:bg-brand-hover transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Continue
      </button>
    </div>
  )
}
